import { z } from 'zod';

export type Region = z.infer<typeof RegionSchema>;
export const RegionSchema = z.object({
  id: z.string().nonempty("Region ID is required."),
  isActive: z.boolean({
    invalid_type_error: "Region active status must be a boolean.",
    required_error: "Region active status is required."
  }),

  name: z.string().nonempty("Region name is required.")
});